import { memo, useState } from "react";
import Modal from "components/shared/modal";
import { toast } from "react-toastify";
import MasterAPI from "service/master";
import { CSSTransition } from "react-transition-group";

const Cancel = props => {
    const { data, mutate } = props;

    const [cancelLoading, setCancelLoading] = useState(false);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [cancelReason, setCancelReason] = useState("");

    const cancelHandler = async e => {
        e.preventDefault();

        if (cancelLoading)
            return;

        setCancelLoading(true);
        try {
            const res = await MasterAPI({
                url: "/api/v2/financial/order/group/change_status",
                payloadType: 3,
                method: "PUT",
                data: {
                    id: data.id,
                    cancel_description: cancelReason,
                    force_action: true,
                    status_id: 7
                },
                callback: () => setCancelLoading(false)
            });

            setShowCancelModal(false);
            toast.success(res.message);
            mutate();
        } catch (e) {
            toast.error(e.message);
        }
    }

    return (
        <>
            <button
                className={`bg-primary-100 hover:bg-primary-200 px-3 transition-colors text-white rounded-md fit-center text-sm h-10 mr-2 relative overflow-hidden`}
                onClick={() => setShowCancelModal(true)}
            >
                <i className="fa-light fa-pen-to-square ml-2"></i>
                لغو سفارش
            </button>

            <Modal
                title="لغو سفارش"
                show={showCancelModal}
                closeHandler={() => setShowCancelModal(false)}
            >
                <form onSubmit={cancelHandler}>
                    <span className="block text-sm mb-4">دلیل لغو خود را بنویسید</span>
                    <textarea
                        value={cancelReason}
                        className="border w-full rounded-lg p-3 text-sm"
                        onChange={e => setCancelReason(e.target.value)}
                    />

                    <button type="submit" className="rounded-lg bg-primary-100 py-2 px-4 text-white text-sm mt-4 relative overflow-hidden">
                        ثبت

                        <CSSTransition in={cancelLoading} timeout={200} unmountOnExit={true}>
                            <span className="pos-cover bg-primary-200 fit-center anim-c4">
                                <i className="fa-solid fa-spinner spin"></i>
                            </span>
                        </CSSTransition>
                    </button>
                </form>
            </Modal>
        </>
    )
}

export default memo(Cancel);